import React, { Component } from "react"
import { connect }          from "react-redux"
import {
    commonLocalization,
    number,
    projectsLocalization,
}                           from "../../../localization"

class FilterTags extends Component {
    render() {
        let { filters } = this.props
        const {
            search,
            page,
            "fiscal-year": year,
            sort_by,
            order_by,
            ...appliedFilters
        } = filters

        return <div className="tags-wrap">{this.renderTags(appliedFilters)}</div>
    }

    renderTags(filters) {
        return Object.keys(filters).map(key => {
            if (!filters[key]) return "";
                return (
                    <div key={"tags-" + key} className="tags">
                    <span>
                        {this.getTitleFromKey(key) + this.getLocalizationValue(key, filters[key])}
                    </span>
                        <span
                            className="remove-keyword"
                            onClick={() => this.props.removeFilter(key)}
                        />
                    </div>
                )
        })
    }

    getLocalizationValue(key, value) { 
        if (key === "project_budget_program") {
            return projectsLocalization[window.language]["project_budget_program"][value];
        }
        if (key === "project_budget_subprogram") {
            return this.props.filters.project_budget_program ? projectsLocalization[window.language]["project_budget_program_type"][this.props.filters.project_budget_program][value] : key;
        }
        if (key === "project_type") {
            return projectsLocalization[window.language][value];
        }
        if (key === "procurement_type") {
            return projectsLocalization[window.language].procurementTypes[value];
        }
        if (key === "project_department") {
            return projectsLocalization[window.language].departments[value];
        }
        if (key === "budget-range") {
            if (window.language === "en") {
                switch (value) {
                    case "0-10000000":
                        return "<10M"
                    case "10000000-20000000":
                        return "10M-20M"
                    case "20000000-30000000":
                        return "20M-30M"
                    case "30000000-40000000":
                        return "30M-40M"
                    default:
                        return value
                }
            } else
                switch (value) {
                    case "0-10000000":
                        return "<१ कराेड"
                    case "10000000-20000000":
                        return "१-२ करोड"
                    case "20000000-30000000":
                        return "२-३ करोड"
                    case "30000000-40000000":
                        return "३-४ करोड"
                    default:
                        return value
                }
        }
        if (key === "status") {
            const localizationCommon = commonLocalization[window.language]

            switch (value) {
                case "pipeline":
                    return localizationCommon.pipeline
                case "completion":
                    return localizationCommon.completion
                case "implementation":
                    return localizationCommon.implementation
                case "cancelled":
                    return localizationCommon.cancelled
                default:
                    return ""
            }
        }
        if (key !== "budgetValue" || window.language === "en") {
            return number(value)
        }
    }

    getTitleFromKey(filter) {
        switch (filter) {
            case "budget-range":
                return window.language === "en" ? "NRs. " : "रु. "

            case "status":
                return ""

            case "ward":
                return window.language === "en" ? "Ward: " : "वडा: "
            default:
                return ""
        }
    }
}

const mapStateToProps = state => ({
    advancedFilters: state.staticData,
})

export default connect(mapStateToProps)(FilterTags)



// WEBPACK FOOTER //
// ./src/pages/project/list/filterTags.js